import { render, staticRenderFns } from "./gj-help.vue?vue&type=template&id=329bd8c1&scoped=true&"
import script from "./gj-help.vue?vue&type=script&lang=js&"
export * from "./gj-help.vue?vue&type=script&lang=js&"
import style0 from "./gj-help.vue?vue&type=style&index=0&id=329bd8c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329bd8c1",
  null
  
)

export default component.exports